import { InitiativeFile } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { OffsetPaginationParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetInitiativeFilesRequest = OffsetPaginationParams & {
	initiativeId: number;
};

export type GetInitiativeFilesResponse = PaginatedResource<InitiativeFile>;

export const getInitiativeFiles = createGetEndpoint<GetInitiativeFilesRequest, GetInitiativeFilesResponse>(
	({ initiativeId, ...rest }) => `/api/v3/initiatives/${initiativeId}/files?${getQueryString(rest)}`
);
